import { useQuery } from "@tanstack/vue-query";
import { fetchRestrictedEmailDomains } from "vue-app-new/api/Register.service";

export const useRestrictedDomains = () => {
  const query = useQuery({
    queryKey: ["restrictedEmailDomains"],
    queryFn: fetchRestrictedEmailDomains,
    staleTime: 1000 * 60 * 60,
    retry: 3,
  });

  return {
    restrictedDomains: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
